import Vue from 'vue'
import axios from "axios";

const OfficeClientAPI = {
    addOfferToOffice: function (reqData, fnOk, fnFailed) {
        Vue.prototype.$api.showIdle({
            show: true, text: 'Die gewählten Inhalte werden nun vom Server auf Ihr Reisebüro TV - Gerät übertragen.<br>Das kann einige Zeit dauern.'
        })
        var cmp = this
        var url = Vue.prototype.$config.HOST + '/v1/pckermax/addOfferImage?time=' + new Date().getTime()
        axios({
            method: 'post',
            url: url,
            params: {
                time: new Date().getTime()
            },
            data: reqData,
            responseType: 'json'
        })
            .then(function (response) {
                Vue.prototype.$api.hideIdle()
                if (fnOk) {
                    fnOk(response.data)
                }
            })
            .catch(error => {
                console.log(error.response)
                Vue.prototype.$api.hideIdle()
                if (fnFailed) {
                    fnFailed(error.response)
                } else {
                    if (cmp) {
                        cmp.onGetError(error)
                    }
                }
            })
    },
    onGetError: function (e) {
        console.error(e)
    },
    getCountries: function (reqData, fnOk, fnFailed) {
        var cmp = this
        var url = Vue.prototype.$config.HOST + '/v1/grequest/countries?time=' + new Date().getTime()
        axios({
            method: 'get',
            url: url,
            params: {
                time: new Date().getTime()
            },
            data: reqData,
            responseType: 'json'
        })
            .then(function (response) {
                Vue.prototype.$api.hideIdle()
                if (fnOk) {
                    fnOk(response.data)
                }
            })
            .catch(error => {
                console.log(error.response)
                Vue.prototype.$api.hideIdle()
                if (fnFailed) {
                    fnFailed(error.response)
                } else {
                    if (cmp) {
                        cmp.onGetError(error)
                    }
                }
            })
    },
    queryHotelByName: function (reqData, fnOk, fnFailed) {
        var cmp = this
        var url = Vue.prototype.$config.HOST + '/v1/grequest/hotelbyname?time=' + new Date().getTime()
        axios({
            method: 'post',
            url: url,
            params: {
                time: new Date().getTime()
            },
            data: reqData,
            responseType: 'json'
        })
            .then(function (response) {
                Vue.prototype.$api.hideIdle()
                if (fnOk) {
                    fnOk(response.data)
                }
            })
            .catch(error => {
                console.log(error.response)
                Vue.prototype.$api.hideIdle()
                if (fnFailed) {
                    fnFailed(error.response)
                } else {
                    if (cmp) {
                        cmp.onGetError(error)
                    }
                }
            })
    },
    getHotelDetail: function (reqData, fnOk, fnFailed) {
        var cmp = this
        var url = Vue.prototype.$config.HOST + '/v1/grequest/hotel?time=' + new Date().getTime()
        axios({
            method: 'post',
            url: url,
            params: {
                time: new Date().getTime()
            },
            data: reqData,
            responseType: 'json'
        })
            .then(function (response) {
                Vue.prototype.$api.hideIdle()
                if (fnOk) {
                    fnOk(response.data)
                }
            })
            .catch(error => {
                console.log(error.response)
                Vue.prototype.$api.hideIdle()
                if (fnFailed) {
                    fnFailed(error.response)
                } else {
                    if (cmp) {
                        cmp.onGetError(error)
                    }
                }
            })
    },
    prepareLogin: function (reqData, fnOk, fnFailed) {
        Vue.prototype.$api.showIdle({
            show: true, text: 'Die gewählten Inhalte werden nun auf dem Server zur Voransicht aufbereitet.<br>Das kann einige Zeit dauern.'
        })
        var cmp = this
        var url = Vue.prototype.$config.HOST + '/v1/pckermax/prepareLogin?time=' + new Date().getTime()
        axios({
            method: 'post',
            url: url,
            params: {
                time: new Date().getTime()
            },
            data: reqData,
            responseType: 'json'
        })
            .then(function (response) {
                Vue.prototype.$api.hideIdle()
                if (fnOk) {
                    fnOk(response.data)
                }
            })
            .catch(error => {
                console.log(error.response)
                Vue.prototype.$api.hideIdle()
                if (fnFailed) {
                    fnFailed(error.response)
                } else {
                    if (cmp) {
                        cmp.onGetError(error)
                    }
                }
            })
    },
    requestOfferImage: function (reqData, fnOk, fnFailed) {
        Vue.prototype.$api.showIdle({
            show: true, text: 'Die gewählten Inhalte werden nun auf dem Server zur Voransicht aufbereitet.<br>Das kann einige Zeit dauern.'
        })
        var cmp = this
        var url = Vue.prototype.$config.HOST + '/v1/pckermax/createOfferImage?time=' + new Date().getTime()
        axios({
            method: 'post',
            url: url,
            params: {
                time: new Date().getTime()
            },
            data: reqData,
            responseType: 'json'
        })
            .then(function (response) {
                Vue.prototype.$api.hideIdle()
                if (fnOk) {
                    fnOk(response.data)
                }
            })
            .catch(error => {
                console.log(error.response)
                Vue.prototype.$api.hideIdle()
                if (fnFailed) {
                    fnFailed(error.response)
                } else {
                    cmp.onGetError(error)
                }
            })
    },
}


export default OfficeClientAPI
